import { render, staticRenderFns } from "./audio-form.vue?vue&type=template&id=172d0158&scoped=true&"
import script from "./audio-form.vue?vue&type=script&lang=js&"
export * from "./audio-form.vue?vue&type=script&lang=js&"
import style0 from "./audio-form.vue?vue&type=style&index=0&id=172d0158&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172d0158",
  null
  
)

export default component.exports